import { render, staticRenderFns } from "./Arrows.vue?vue&type=template&id=296fb973&scoped=true"
import script from "./Arrows.vue?vue&type=script&lang=js"
export * from "./Arrows.vue?vue&type=script&lang=js"
import style0 from "./Arrows.vue?vue&type=style&index=0&id=296fb973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296fb973",
  null
  
)

export default component.exports